<template>
  <span class="svg-icon-play-circle">
    <svg :style="`width:${width}px;height:${width}px;fill:none;`" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.9697 2C6.44973 2 1.96973 6.48 1.96973 12C1.96973 17.52 6.44973 22 11.9697 22C17.4897 22 21.9697 17.52 21.9697 12C21.9697 6.48 17.4997 2 11.9697 2ZM14.9697 14.23L12.0697 15.9C11.7097 16.11 11.3097 16.21 10.9197 16.21C10.5197 16.21 10.1297 16.11 9.76973 15.9C9.04973 15.48 8.61973 14.74 8.61973 13.9V10.55C8.61973 9.72 9.04973 8.97 9.76973 8.55C10.4897 8.13 11.3497 8.13 12.0797 8.55L14.9797 10.22C15.6997 10.64 16.1297 11.38 16.1297 12.22C16.1297 13.06 15.6997 13.81 14.9697 14.23Z" :fill="color"/>
    </svg>
  </span>
</template>

<script>
export default {
  props: {
    width: { type: Number, default: 24 },
    color: { type: String, default () { return this.$store.state.color['coolGrey-500'] } }
  }
}
</script>
